import React from "react";

import style from "./style.module.css";

export default function Editor({text, inherit}) {
    return (
        <div className={inherit ? style.inherit : undefined}>
            <div className={style.cEditor} dangerouslySetInnerHTML={{ __html: text }} />
        </div>
    )
}